import { render, staticRenderFns } from "./PlantsHandbook.vue?vue&type=template&id=250f7a3d&scoped=true&"
import script from "./PlantsHandbook.vue?vue&type=script&lang=js&"
export * from "./PlantsHandbook.vue?vue&type=script&lang=js&"
import style0 from "./PlantsHandbook.vue?vue&type=style&index=0&id=250f7a3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250f7a3d",
  null
  
)

export default component.exports